import { checkContrast } from '../../utils';
import { HoneycombThemeBase } from '../types';

export function getContrastTextColor(theme: HoneycombThemeBase) {
    return (color: string) => {
        const { palette } = theme;
        const { inverse, body } = palette.text;
        return checkContrast(color, inverse) ? inverse : body;
    };
}
